import React from "react";
import Like from "../../assets/images/like.png";
import Love from "../../assets/images/love.png";
import Care from "../../assets/images/care.png";

export function CommentBox({
  profileImg,
  name,
  text,
  time,
  reactionsCount
}: {
  profileImg: string;
  name: string;
  text: string;
  time: string;
  reactionsCount: number;
}) {
  return (
    <div className="flex items-start space-x-3 w-full mb-4">
      <div className="flex flex-col items-center">
        <img
          src={profileImg}
          alt={`${name}'s profile`}
          className="w-9 h-9 rounded-full"
        />
        <div className="flex-1 border-l-2 border-gray-200 w-px mt-1" />
      </div>
      <div className="flex-1">
        <div className="bg-gray-100 rounded-2xl p-3">
          <p className="font-bold text-sm leading-none">{name}</p>
          <p className="text-sm mt-1 leading-snug">{text}</p>
        </div>
        <div className="text-xs text-gray-500 mt-1 flex items-center gap-3">
          <span>{time}</span>
          <span className="font-semibold cursor-pointer hover:underline">
            Like
          </span>
          <span className="font-semibold cursor-pointer hover:underline">
            Reply
          </span>
          <div className="ml-auto flex items-center">
            <span className="text-gray-600 font-medium">{reactionsCount}</span>
            <span className="flex items-center ml-1">

            <img src={Like} className="w-4 h-4" alt="like" />
            <img src={Love} className="w-4 h-4" alt="love" />
            <img src={Care} className="w-4 h-4" alt="care" />
            </span>
          </div>
        </div>
        <div className="text-sm text-gray-700 font-semibold mt-1 ml-4 border-l-2 border-gray-200 pl-4">
          View all replies
        </div>
      </div>
    </div>
  );
}

export default CommentBox;
